var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "m-0"
  }, [_vm.$options.components['advertisement-banner'] ? [_c('advertisement-banner')] : _vm._e()], 2), _c('div', [_c('b-row', [_vm.filterProduct.length != 0 ? _c('b-col', {
    staticClass: "mx-3 my-4 text-grey",
    attrs: {
      "cols": "3"
    }
  }, [_vm.$options.components['search-side-bar'] ? [_c('search-side-bar', {
    on: {
      "allFilters": _vm.allfilter
    }
  })] : _vm._e()], 2) : _vm._e(), _c('b-col', {
    staticClass: "mt-4 mb-4",
    attrs: {
      "cols": "8"
    }
  }, [_vm.filterProduct.length != 0 ? _c('div', {
    staticClass: "row text-grey"
  }, [_c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('h4', {
    staticClass: "font-weight-bold mb-0"
  }, [_vm._v(" " + _vm._s(_vm.$route.params.id[0].toUpperCase() + _vm.$route.params.id.substring(1).toLowerCase()) + " ")])]), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('select', {
    staticClass: "form-select filter-select form-control border",
    on: {
      "change": function ($event) {
        return _vm.onChangeSort($event);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Sorting price")]), _c('option', {
    attrs: {
      "value": "low"
    }
  }, [_vm._v("price, low to high")]), _c('option', {
    attrs: {
      "value": "high"
    }
  }, [_vm._v("price, high to low")])])])], 1) : _vm._e(), _c('div', {
    staticClass: "mt-4"
  }, [_vm.filterProduct.length == 0 ? _c('div', {
    staticClass: "text-center section-t-space section-b-space"
  }, [_c('b-row', {
    staticClass: "my-1 ml-5"
  }, [_c('b-col', {
    attrs: {
      "cols": "5"
    }
  }), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "7"
    }
  }, [_c('b-img', {
    attrs: {
      "inline": "",
      "src": "img/search/empty-search.jpg",
      "fluid": ""
    }
  }), _c('h3', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" Sorry , Couldn't find the result you were looking For! ")]), _c('p', [_vm._v(" Please check your spelling or try searching something else. ")]), _c('b-navbar-brand', {
    attrs: {
      "href": "/"
    }
  }, [_c('b-button', {
    staticClass: "my-1",
    attrs: {
      "variant": "warning"
    }
  }, [_vm._v("Continue Shopping")])], 1)], 1)], 1)], 1) : _vm._e(), _c('b-row', _vm._l(_vm.filterProduct, function (item, i) {
    return _c('b-col', {
      key: i,
      staticClass: "slideItem",
      attrs: {
        "md": "3",
        "sm": "6",
        "xs": "12"
      }
    }, [_c('div', {
      staticClass: "product-box card shop-box-right"
    }, [_vm.$options.components['items-product-card'] ? [_c('items-product-card', {
      key: i,
      attrs: {
        "cartItem": item
      }
    })] : _vm._e()], 2)]);
  }), 1)], 1)])], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }